// extracted by mini-css-extract-plugin
export default {"headerRight":"LibraryContentHeaderRight-module__headerRight_ms2Ht"};